import icon1 from "../../assets/images/serviceicon1.svg"
import icon2 from "../../assets/images/serviceicon2.svg"
import icon3 from "../../assets/images/serviceicon3.svg"
import icon4 from "../../assets/images/serviceicon4.svg"
import icon5 from "../../assets/images/serviceicon5.svg"
import icon6 from "../../assets/images/serviceicon6.svg";
import arrow from "../../assets/images/arrow.svg"
import { motion } from 'motion/react'

type ServiceType = {
  icon: string;
  title: string;
  text: string;
}

const services: ServiceType[] = [
  {
    icon: icon1,
    title: "Risk Management & Compliance",
    text: "Maintaining compliance with healthcare laws while rapidly minimising financial risks",
  },
  {
    icon: icon2,
    title: "Strategic Financial Planning",
    text: "Creating tailored fiscal strategies that meet the specific requirements of the healthcare industry as well as the goals of your business.",
  },
  {
    icon: icon3,
    title: "Mergers & Acquisitions",
    text: "Optimising value and guaranteeing smooth transitions through mergers and acquisitions by offering expert guidance.",
  },
  {
    icon: icon4,
    title: "Operational Cost Optimization",
    text: "Implementing cost-saving initiatives that streamline operations and improve cash flow without compromising quality.",
  },
  {
    icon: icon5,
    title: "Revenue Growth & Profitability Analysis",
    text: "Using data-driven analytics and efficiency tactics to boost long-term revenue growth",
  },
  {
    icon: icon6,
    title: "Financial Forecasting & Budgeting",
    text: "Developing precise budgets and financial projections to facilitate well-informed decision-making",
  },
];

const Service = () => {
  return (
    <div className="max-w-screen-2xl mx-auto">
      <div className="bg-primary bg-opacity-5 px-5 sm:px-20 py-10 sm:py-28 sm:rounded-tr-[250px]">
        <div className="flex flex-col justify-center sm:items-center">
          <div className="relative mb-9">
            <motion.h3
              initial={{ y: -100, opacity: 0 }}
              whileInView={{ y: 0, opacity: 1 }}
              transition={{ duration: 0.5 }}
              viewport={{ once: true }}
              className="poppins-regular text-primary z-20 relative"
            >
               SERVICES WE OFFER
            </motion.h3>
            <div className="size-16 bg-[#ffff] rounded-full absolute -top-5 -left-5"></div>
          </div>
          <motion.h2
            initial={{ y: -100, opacity: 0 }}
            whileInView={{ y: 0, opacity: 1 }}
            transition={{ duration: 0.5, delay: 0.5 }}
            viewport={{ once: true }}
            className="text-4xl sm:text-5xl montserrat-regular text-secondary sm:text-center mb-6"
          >
            <span className="montserrat-semibold">Financial</span> Services For
            A <br /> Stronger{" "}
            <span className="montserrat-semibold">Medical Industry</span>
          </motion.h2>
          <motion.p
            initial={{ y: -100, opacity: 0 }}
            whileInView={{ y: 0, opacity: 1 }}
            transition={{ duration: 0.5, delay: 1 }}
            viewport={{ once: true }}
            className="montserrat-regular text-secondary sm:text-center mb-6"
          >
            Helping healthcare organizations thrive with strategic financial
            planning and optimization. I deliver solutions that enhance growth,
            stability, and long-term success in the medical industry
          </motion.p>
        </div>
        <div className=" grid lg:grid-cols-2 xl:grid-cols-3 gap-4">
          {services.map((item) => (
            <div
              key={item.title}
              className=" border border-primary rounded-xl group cursor-pointer"
            >
              <div className="group-hover:bg-primary pt-8 px-10 h-full rounded-lg transition-all duration-300">
                {" "}
                <img
                  src={item.icon}
                  alt=""
                  className="mb-8 group-hover:-translate-y-6 group-hover:opacity-0 transition-all duration-500"
                />
                <h3 className="text-secondary group-hover:-translate-y-6 transition-all duration-500 montserrat-semibold text-2xl mb-6 group-hover:text-white ">
                  {item.title}
                </h3>
                <p className="montserrat-regular text-secondary group-hover:-translate-y-6 group-hover:text-white transition-all duration-500">
                  {item.text}
                </p>
                <a href="/contact" onClick={() => window.scrollTo(0, 0)}>
                  <div className="opacity-0 flex group-hover:opacity-100 gap-4 group-hover:-translate-y-6 transition-all duration-500 mt-6 montserrat-semibold text-white cursor-pointer">
                    Contact Us <img src={arrow} alt=""/>
                  </div>
                </a>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default Service